import { retailerSettingsService } from '../../../services/retailer-settings/retailer-settings';
import { returnItemsService } from '../../../services/return-items-service/return-items-service';
import { getOrderGroups } from '../utils';
import { store } from '../../../store';
import { getReturnCollection, mutations } from './utils';

export const useMultiOrder = () => {
  const {
    language,
    page: { locale },
    multiOrders: { orders },
    orderInfo,
    orderService: { retailerEligibilities },
    claims: { enabled: claimsEnabled },
  } = store.getState();

  const allOrders = [orderInfo.orderData, ...orders];
  const exchangeEnabled = retailerSettingsService.getIsExchangeEnabled();
  const returnCart = returnItemsService.getItems();
  const { ignoreReturnLabels = false } = retailerSettingsService.getSettings();

  const collections = getReturnCollection({
    ignoreReturnLabels,
    allOrders,
    retailerEligibilities,
    language,
    locale,
    exchangeEnabled,
    claimsEnabled,
  });

  const elItems = collections.some((e) => e.byDay && e.byDay.length > 0)
    ? collections
        .map((e) => e.byDay)
        .flat()
        .map((e) => Object.values(e.items).flat())
        .flat()
    : collections.map((e) => e.items).flat();

  const itemOrderGroups = getOrderGroups({
    items: mutations({
      items: elItems,
      mutationConfigs: [{ type: 'quantity', key: 'remaining_qty' }],
    }),
    orders: allOrders,
  });

  const orderGroups = Object.values(itemOrderGroups);

  return {
    byDay: collections.map((e) => e.byDay).flat(),
    byTimestamp: collections.map((e) => e.byTimestamp).flat(),
    ineligibleByDay: collections.map((e) => e.ineligibleByDay).flat(),
    returnCart,
    exchangeEnabled,
    allItems: collections.map((e) => e.allItems).flat(),
    naItems: collections.map((e) => e.naItems).flat(),
    items: collections.map((e) => e.items).flat(),
    orderGroups,
    allOrders,
    returnLabels: collections.map((e) => e.returnLabels).flat(),
  };
};
